import React, { Component } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import cx from 'classnames'
import premiumAccess from '../../images/premium3.png'

export default class MobilePreferencesForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      expanded: true
    }
    this.toggleExpand = this.toggleExpand.bind(this)
  }

  toggleExpand() {
    this.setState({ expanded: !this.state.expanded })
  }

  render() {
    const {
      fields: { servicingCompletions, issues, unsatisfactory },
      error,
      submitting,
      handleSubmit,

      enabled,
    } = this.props
    const {
      expanded
    } = this.state
    const isSupervisor = (this.props.userType === 'Supervisor')
    const premiumImg = (isSupervisor) ? (<img src={premiumAccess} className='premium notifications' alt='premiumAccess' width={18} height={18} />) : null

    return (
      <form onSubmit={handleSubmit}>
        <div className="expandable">
          <h1>Mobile Notifications</h1>
          <img onClick={this.toggleExpand} className={cx('toggle-button', { '_up': expanded })} src={require('../../images/arrow-down.svg')} />
          { expanded &&
            <ReactCSSTransitionGroup
              component='div'
              transitionName='workOrderGroup'
              transitionEnterTimeout={250}
              transitionLeaveTimeout={250}
            >
              {!enabled ?
                <p>Notifications are disabled on your mobile device. <br />
                  Please turn push notifications On via the settings screen of the MAATS app.</p>
                :
                <div
                  className='checkbox-group'
                  {...!enabled && { disabled: true }}
                >
                  <div className='checkboxes-container'>
                    <div>
                      <label textAlignVertical='center'>
                        <input
                          {...!enabled && { disabled: true }  }
                          type='checkbox'
                          disabled={isSupervisor}
                          value={servicingCompletions.value}
                          {...servicingCompletions}
                          onChange={event => {
                            servicingCompletions.onChange(event)
                            setTimeout(handleSubmit)
                          }}/>
                        <span className='indicator'></span>
                        Servicing Completions
                        {premiumImg}
                      </label>
                    </div>
                    <div>
                      <label>
                        <input
                        type='checkbox'
                        value={issues.value}
                        disabled={isSupervisor}
                        {...issues}
                        onChange={event => {
                          issues.onChange(event)
                          setTimeout(handleSubmit)
                        }}/>
                        <span className='indicator'></span>
                        Issues
                        {premiumImg}
                      </label>
                    </div>
                    <div>
                      <label>
                        <input
                        type='checkbox'
                        value={unsatisfactory.value}
                        disabled={isSupervisor}
                        {...unsatisfactory}
                        onChange={event => {
                          unsatisfactory.onChange(event)
                          setTimeout(handleSubmit)
                        }}/>
                        <span className='indicator'></span>
                        Unsatisfactory
                        {premiumImg}
                      </label>
                    </div>
                  </div>
                </div>
              }
            </ReactCSSTransitionGroup>
          }
        </div>
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/settings/mobile-preferences-form.js